/* CoinZii-matched KPI card with colored gradient border + delta indicator */
import { TrendingUp, TrendingDown } from "lucide-react";

const VARIANTS = {
  green: { border: "rgba(16, 185, 129, 0.4)", glow: "rgba(16, 185, 129, 0.10)", icon: "#10B981" },
  yellow: { border: "rgba(240, 184, 58, 0.4)", glow: "rgba(240, 184, 58, 0.10)", icon: "#F0B83A" },
  blue: { border: "rgba(59, 130, 246, 0.4)", glow: "rgba(59, 130, 246, 0.10)", icon: "#3B82F6" },
  red: { border: "rgba(239, 68, 68, 0.4)", glow: "rgba(239, 68, 68, 0.10)", icon: "#EF4444" },
  purple: { border: "rgba(139, 92, 246, 0.4)", glow: "rgba(139, 92, 246, 0.10)", icon: "#8B5CF6" },
  cyan: { border: "rgba(6, 182, 212, 0.4)", glow: "rgba(6, 182, 212, 0.10)", icon: "#06B6D4" },
};

export default function KpiCard({ label, value, delta, deltaLabel, icon: Icon, variant = "yellow", testid }) {
  const v = VARIANTS[variant] || VARIANTS.yellow;
  const positive = typeof delta === "string" && delta.trim().startsWith("+");
  const negative = typeof delta === "string" && delta.trim().startsWith("-");
  return (
    <div
      className="relative rounded-[14px] p-5 overflow-hidden"
      style={{
        background: `linear-gradient(180deg, ${v.glow} 0%, transparent 80%), #0F1626`,
        border: `1px solid ${v.border}`,
      }}
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="text-[12px] text-[#8892A8]">{label}</div>
          <div className="text-[28px] font-bold mt-1.5 tabular-nums leading-tight truncate">{value}</div>
          {(delta || deltaLabel) && (
            <div className="flex items-center gap-1 mt-1.5 text-[11px]">
              {delta && (
                <span className={`inline-flex items-center gap-0.5 font-bold ${positive ? "text-[#10B981]" : negative ? "text-[#EF4444]" : "text-[#8892A8]"}`}>
                  {positive && <TrendingUp size={10} />}
                  {negative && <TrendingDown size={10} />}
                  {delta}
                </span>
              )}
              {deltaLabel && <span className="text-[#5A6582]">{deltaLabel}</span>}
            </div>
          )}
        </div>
        {Icon && (
          <div className="w-9 h-9 rounded-[10px] grid place-items-center" style={{ background: `${v.icon}22`, color: v.icon }}>
            <Icon size={16} />
          </div>
        )}
      </div>
    </div>
  );
}
